export function formatPrice(amount) {
    return `$${amount.toFixed(2)}`;
}
